export const storyTemplateFormMessages = {
  // Form title and description
  title: 'Create Story Template',
  subtitle: 'Design a new story template for generating characters',

  // Form field labels
  titleLabel: 'Template Title',
  titlePlaceholder: 'Enter a title for your story template',
  descriptionLabel: 'Description',
  descriptionPlaceholder: 'Describe what this story template is about',
  ageRangeLabel: 'Age Range',
  ageRangeDescription: 'Select the target age range for this story',
  ageRangePlaceholder: 'Select an age range',
  storyThemesLabel: 'Story Themes',
  storyThemesDescription:
    'Select all themes that apply to this story (you can choose multiple)',
  keyEventsLabel: 'Key Events (Optional)',
  keyEventsDescription: 'Important plot points or events in the story',
  keyEventsPlaceholder: 'Enter a key event',
  settingDetailsLabel: 'Setting Details (Optional)',
  settingDetailsDescription: 'Describe the story setting and atmosphere',
  settingDetailsPlaceholder: 'Describe the story setting...',
  styleTemplateLabel: 'Style Template (Optional)',
  styleTemplateDescription: 'Choose a style template to apply to this story',
  styleTemplatePlaceholder: 'Select a style template',
  rolesLabel: 'Story Roles',
  rolesDescription: 'Define the characters needed for this story',

  // Role template fields
  roleTemplateLabel: 'Role Template',
  roleTemplatePlaceholder: 'Select a role template',

  // Age range options - nested object structure
  ageRangeOptions: {
    '0-3': '0-3 years',
    '3-6': '3-6 years',
    '6-9': '6-9 years',
    '9-12': '9-12 years',
    '12-18': '12-18 years',
  },

  // Buttons
  addRoleButton: 'Add Role',
  removeRoleButton: 'Remove Role',
  addKeyEventButton: 'Add Key Event',
  removeKeyEventButton: 'Remove Key Event',
  createTemplateButton: 'Create Template',
  cancelButton: 'Cancel',

  // Validation messages
  titleRequired: 'Title is required',
  descriptionRequired: 'Description is required',
  ageRangeRequired: 'Age range is required',
  storyThemesRequired: 'At least one story theme is required',
  roleNameRequired: 'Role name is required',
  roleDescriptionRequired: 'Role description is required',
  atLeastOneRole: 'At least one role is required',

  // Status messages
  creating: 'Creating template...',
  success: 'Story template created successfully!',
  error: 'Failed to create story template',

  // Loading states
  loadingRoleTemplates: 'Loading role templates...',
  loadingStyleTemplates: 'Loading style templates...',

  // Accessibility
  addRoleAriaLabel: 'Add a new role to the story template',
  removeRoleAriaLabel: 'Remove this role from the story template',
  addKeyEventAriaLabel: 'Add a new key event to the story',
  removeKeyEventAriaLabel: 'Remove this key event from the story',
  formAriaLabel: 'Story template creation form',
} as const;
